"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobxReactForm = require("mobx-react-form");

var _mobx = require("mobx");

var _showWhen = _interopRequireDefault(require("../rules/showWhen"));

var _hideWhen = _interopRequireDefault(require("../rules/hideWhen"));

var _mandatoryWhen = _interopRequireDefault(require("../rules/mandatoryWhen"));

var _isRequired = _interopRequireDefault(require("../validators/isRequired"));

var _mandatoryWhenNot = _interopRequireDefault(require("../rules/mandatoryWhenNot"));

var _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var Field = (_class = /*#__PURE__*/function (_MobxReactField) {
  _inherits(Field, _MobxReactField);

  var _super = _createSuper(Field);

  function Field(props, form) {
    var _this;

    _classCallCheck(this, Field);

    _this = _super.call(this, props);
    _this.form = form; //this.storedValidators = props.data && props.data.validators;

    _this.storedValidators = null;

    if (_this.validators && _this.validators.length) {
      _this.storedValidators = _this.validators.slice(0); // Clone validators
    }

    _this.registrations = 0;

    _this.set('validators', null);

    return _this;
  } //setManuallyChanged to true if we need to manually update the form state to 'dirty', i.e when we use .add() or .del()


  _createClass(Field, [{
    key: "setManuallyChanged",
    value: function setManuallyChanged(changed) {
      this.state.form.setManuallyChanged(changed);
    }
  }, {
    key: "register",
    value: function register() {
      var _this2 = this;

      /**
       * To handle conditionally mandatory fields, we need to listen to changes and manage the list of validators
       * and add a required rule when it's needed.
       * The autorun function will automatically track it's dependencies, and returns a dispose function, which we
       * call when the field unregisters.
       */
      if (!this.disposeRequiredWatcher) {
        this.disposeRequiredWatcher = (0, _mobx.autorun)(function () {
          if (_this2.computedIsRequired) {
            var validators = _this2.storedValidators ? [].concat(_toConsumableArray(_this2.storedValidators), [(0, _isRequired.default)(_this2.extra.requiredMessage)]) : [(0, _isRequired.default)(_this2.extra.requiredMessage)];

            _this2.set('validators', validators);
          } else {
            _this2.set('validators', _this2.storedValidators);
          }
        });
      } else {
        if (this.storedValidators && this.storedValidators.length) {
          this.set('validators', this.storedValidators);
        }
      }

      this.registrations += 1;
    }
  }, {
    key: "unregister",
    value: function unregister() {
      this.registrations -= 1;
      /**
       * If there are no registrations we know that the field is no longer visible and should not be validated.
       */

      if (this.registrations < 1) {
        /**
         * Dispose of the autorun watcher that handles conditionally required fields.
         */
        if (this.disposeRequiredWatcher) {
          this.disposeRequiredWatcher();
          this.disposeRequiredWatcher = null;
        }

        this.set('validators', null); //this.reset();
      }
    }
  }, {
    key: "isShown",
    get: function get() {
      if (!this.extra) {
        return true;
      }

      var rules = this.extra.rules;

      if (!rules || !rules.length) {
        return true;
      }

      for (var i = 0; i < rules.length; i = i + 1) {
        var rule = rules[i];

        switch (rule.type) {
          case 'show-when':
            return (0, _showWhen.default)(this, rule.data, this.form);

          case 'hide-when':
            return !(0, _hideWhen.default)(rule.data, this.form);

          default:
            break;
        }
      }

      return true;
    }
  }, {
    key: "computedIsRequired",
    get: function get() {
      if (!this.extra) {
        return false;
      }

      var _this$extra = this.extra,
          rules = _this$extra.rules,
          required = _this$extra.required;

      if (!rules || !rules.length) {
        return required;
      }

      for (var i = 0; i < rules.length; i = i + 1) {
        var rule = rules[i];

        switch (rule.type) {
          case 'mandatory-when':
            if ((0, _mandatoryWhen.default)(rule.data, this.form)) {
              return true;
            }

            break;

          case 'mandatory-when-not':
            if ((0, _mandatoryWhenNot.default)(this, rule.data, this.form)) {
              return true;
            }

            break;

          default:
            break;
        }
      }

      return required;
    }
  }]);

  return Field;
}(_mobxReactForm.Field), (_applyDecoratedDescriptor(_class.prototype, "setManuallyChanged", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setManuallyChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isShown", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isShown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "computedIsRequired", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "computedIsRequired"), _class.prototype)), _class);
var _default = Field;
exports.default = _default;
//# sourceMappingURL=Field.js.map